const theme = {
  colors: {
    primary: '#4A90E2',
    secondary: '#172B4D',
    background: '#f8f9fa',
    text: '#2b2b2b',
    accent: '#FFD700', // Gold accent for CTAs
    white: '#FFFFFF',
  },
  fonts: ['Montserrat', 'sans-serif'],
  fontSizes: {
    small: '14px',
    medium: '18px',
    large: '24px',
  },
};
  export default theme;
  